import { Component, ComponentRef, ElementRef, EventEmitter, HostListener, OnInit, OnDestroy, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CreationPatient } from 'src/app/utils/interfaces/new/creation-patient.interface';
import * as moment from 'moment';
import { CabinetService } from 'src/app/services/office/cabinet.service';
import { Referentiel } from 'src/app/utils/interfaces/new/referentiel.interface';
import { ReferentielService } from 'src/app/services/referentiel/referentiel.service';
import { ReferentielEnum } from 'src/app/utils/enums/referentiel-enum';
import { LoginService } from 'src/app/services/login/login.service';
import { InfosPatientCarteVitale } from 'src/app/utils/interfaces/new/infos-patient-carte-vitale.interface';
import { ModalService } from 'src/app/services/modal/modal.service';
import { CouverturePatient } from 'src/app/utils/interfaces/new/couverture-patient.interface';
import { CpxSessionInterface } from 'src/app/utils/interfaces/new/cpx-session.interface';
import { CpxHandleServiceAbstract } from 'src/app/services/cpx-handle/cpx-handle-service-abstract';
import { InsRealservice } from 'src/app/services/ins/ins.service';
import { CannotOpenSession, CannotReadVitale, CpxCard, MultipleVitaleCards, NoVitaleCard, VitaleCardRipped } from 'src/app/services/cpx-handle/cpx-handle.error';
import { PatientService } from 'src/app/services/patient/patient.service';
import { SelectListFragment } from '../select-list/select-list.fragment';
import { Patients } from 'src/app/utils/interfaces/new/lecture-carte-vitale';
import { Identity } from 'src/app/utils/interfaces/new/lecture-ins.interface';
import { REGEX_NAME, StringUtilsService } from 'src/app/services/string-utils/string-utils.service';
import { DroitsService } from 'src/app/services/droits/droits.service';
import { DroitAcces } from 'src/app/utils/interfaces/new/combinateddroits.interface';
import { MultipleIdentitiesFound, NoIdentityFound, NotSameVitaleCard } from 'src/app/services/ins/ins.error';
import { LoadingModalFragment } from '../loading/loading-modal.fragment';
import { environment } from 'src/environments/environment';
import { FiltrePatient } from 'src/app/utils/interfaces/new/filtre-patient.interface';
import { ApiMetadataService } from 'src/app/services/api-metadata/api-metadata.service';
import { Commune } from 'src/app/utils/interfaces/new/commune.interface';
import { Observable, of, Subject, Subscription } from 'rxjs';
import { catchError, finalize, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';
@Component({
  selector: 'app-add-patient',
  templateUrl: './add-patient.fragment.html',
  styleUrls: [
    './add-patient.fragment.scss',
    '../modal.fragment.scss'
  ]
})

// Ce fragment sera amené a évolué
export class AddPatientFragment implements OnInit, OnDestroy {

  constructor(
    private _formBuilder: FormBuilder,
    private _cabinet: CabinetService,
    private _ref: ReferentielService,
    private _login: LoginService,
    private _view: ViewContainerRef,
    private _modalService: ModalService,
    private _cpxHandleSrv: CpxHandleServiceAbstract,
    private _insSrv: InsRealservice,
    private _patientService: PatientService,
    private _strUtilsSrv: StringUtilsService,
    private _droitService: DroitsService,
    public _apiMetadataSrv: ApiMetadataService,
    private _snackBar: SnackbarService
  ) { }

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  public modalTitle: string;
  public formGroup: FormGroup;
  public isError = false;
  public errorMessage = '';
  public currentUser: any;
  public cpxSession: CpxSessionInterface;
  public docsIdentiteList: Referentiel[];
  public attributsIdentiteList: Referentiel[];

  public infosFromInsi = false;
  public maskInsAndCV = false;
  public maxDate = moment().format('YYYY-MM-DD');
  public minDate = moment((moment().year() - 150) + '-' + moment().month() + '-' + moment().day()).format('YYYY-MM-DD');

  private patientVitaleColumnTable = [
    { title: 'Nom', data: 's_name' },
    { title: 'Nom de naissance', data: 's_birthname' },
    { title: 'Prénom', data: 's_given' },
    { title: 'Date de naissance', data: 's_birthday' },
    { title: 'NIR', data: 's_nir' },
    { title: 'INSC', data: 's_insC' },
  ];

  @Output() public closeEmitter = new EventEmitter();
  insRight: DroitAcces;

  titres: Referentiel[];

  sexes = [
    { id: 'HOMME', libelle: 'HOMME' },
    { id: 'FEMME', libelle: 'FEMME' },
    { id: 'INDETERMINE', libelle: 'INDÉTERMINÉ' }
  ];

  responsables = [];

  public infosPatient: InfosPatientCarteVitale & { cpNaissance?: string; insc?: string; sexe?: number; insKey?: string; };
  public couverturePatient: CouverturePatient;

  public isSubmitDisabled = false;
  public communesNaissance$: Observable<Commune[]>;
  public paysList: any[] = [];
  public isDomTomChecked = false;
  public activeSearchField: 'ville' | 'code' | null = null;
  private searchVilleSubject = new Subject<string>();
  private searchVilleSub: Subscription;

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeAddEditModal();
    }
  }

  async ngOnInit(): Promise<void> {
    this.searchVilleSub = this.searchVilleSubject.pipe(
      debounceTime(400),
      distinctUntilChanged()
    ).subscribe(value => {
      this.executeSearchVille(value);
    });

    this.titres = await this._ref.findRefListTable(ReferentielEnum.titre);
    this.currentUser = this._login.getCurrentProfil();

    const destinatairesCabinet = await this._cabinet.findCurrentCabinetDestinataire();
    const combinatedRights = await this._droitService.findMyCombinedDroits();
    this.insRight = combinatedRights.droits.find(x => x.nom === 'Ins');

    for (const destinataire of destinatairesCabinet) {
      if (!destinataire.disabled) {
        this.responsables.push({ id: destinataire.id, libelle: destinataire.nom.toLocaleUpperCase() + ' ' + this._strUtilsSrv.uppercaseFirstCharString(destinataire.prenom) });
      }
    }
    
    try {
      const pays = await this._apiMetadataSrv.searchPaysByName('').toPromise();
      pays.sort((a: any, b: any) => {
        if (a.intitule.toLowerCase() === 'france') return -1;
        if (b.intitule.toLowerCase() === 'france') return 1;
        return a.intitule.localeCompare(b.intitule, 'fr', { sensitivity: 'base' });
      });
      this.paysList = pays.map((p: any) => ({
        id: p.code,
        libelle: `${p.intitule} - ${p.code}`,
        code: p.code
      }));
      this.paysList.unshift({ id: 'INCONNU', libelle: 'INCONNU', code: 'INCONNU' });
    } catch (e) {
      console.error('Erreur chargement pays:', e);
    }

    if (this.infosPatient) {
      this.initPatientForm();
    } else {
      this.formGroup = this._formBuilder.group({
        titre: [''],
        sexe: ['', Validators.required],
        nom: ['', [Validators.pattern(REGEX_NAME)]],
        nomNaissance: ['', [Validators.required, Validators.pattern(REGEX_NAME)]],
        prenomsNaissance: ['', [Validators.pattern(REGEX_NAME)]],
        prenom: ['', [Validators.required, Validators.pattern(REGEX_NAME)]],
        dateNaissance: ['', Validators.required],
        cpNaissance: ['', [Validators.required, Validators.pattern('^[0-9]*$'), Validators.maxLength(5)]],
        responsable: [this.currentUser.id, Validators.required],
        consentement: [true],
        adresse: [''],
        compAdresse: [''],
        codePostal: ['', [Validators.pattern('^[0-9]*$'), Validators.maxLength(5)]],
        ville: [''],
        email: ['', Validators.email],
        telephone: ['', this.checkPhoneNumber],
        note: [''],
        ins: [''],
        insKey: [''],
        oid: [''],
        prenomUsage: '',
        idDocIdentite: [''],
        idAttrIdentite: [''],
        forceIdentiteValidation: [false],
        villeNaissance: [''],
        paysNaissance: [''],
        lieuNaissanceInconnu: [false]
      });
    }

    this.formGroup.get('lieuNaissanceInconnu').valueChanges.subscribe(checked => {
      if (checked) {
        this.formGroup.get('villeNaissance').setValue('INCONNU');
        this.formGroup.get('cpNaissance').setValue('99999');
        this.formGroup.get('paysNaissance').setValue('INCONNU');
        this.communesNaissance$ = null;
      } else {
        if (this.formGroup.get('villeNaissance').value === 'INCONNU') {
          this.formGroup.get('villeNaissance').setValue('');
        }
        if (this.formGroup.get('cpNaissance').value === '99999') {
          this.formGroup.get('cpNaissance').setValue('');
        }
        if (this.formGroup.get('paysNaissance').value === 'INCONNU') {
          this.formGroup.get('paysNaissance').setValue('');
        }
      }
    });

    this.formGroup.valueChanges.subscribe(() => {
      // Reset des erreurs à la modification du formulaire
      this.errorMessage = '';
      this.isError = false;
    });
  }

  private initPatientForm(): void {
    this.formGroup = this._formBuilder.group({
      titre: [''],
      sexe: [this.infosPatient.sexe ? this._sexIdxToStr(this.infosPatient.sexe) : '', Validators.required],
      nom: [this._strUtilsSrv.uppercaseWithoutAccents(this.infosPatient.nom), [Validators.required, Validators.pattern(REGEX_NAME)]],
      nomNaissance: [this._strUtilsSrv.uppercaseWithoutAccents(this.infosPatient.nomNaissance), [Validators.required, Validators.pattern(REGEX_NAME)]],
      prenomsNaissance: [this.infosPatient.prenom ? this._strUtilsSrv.uppercaseWithoutAccents(this.infosPatient.prenom) : '', [Validators.pattern(REGEX_NAME)]],
      prenom: [this.infosPatient.prenom ? this._strUtilsSrv.uppercaseWithoutAccents(this.infosPatient.prenom) : '', [Validators.required, Validators.pattern(REGEX_NAME)]],
      dateNaissance: [moment(this.infosPatient.birthday, 'DD/MM/YYYY').toDate(), Validators.required],
      cpNaissance: [this.infosPatient.cpNaissance, [Validators.required, Validators.pattern('^[0-9]*$'), Validators.maxLength(5)]],
      responsable: [this.currentUser.id, Validators.required],
      consentement: [true],
      adresse: [this.infosPatient.adresse ? this.infosPatient.adresse : ''],
      compAdresse: [this.infosPatient.compAdresse ? this.infosPatient.compAdresse : ''],
      codePostal: [this.infosPatient.codePostal ? this.infosPatient.codePostal : '', [Validators.pattern('^[0-9]*$'), Validators.maxLength(5)]],
      ville: [this.infosPatient.ville ? this.infosPatient.ville : ''],
      email: ['', Validators.email],
      telephone: ['', this.checkPhoneNumber],
      note: [''],
      insc: [this.infosPatient.insc ? this.infosPatient.insc : ''],
      ins: [this.infosPatient.ins],
      insKey: [this.infosPatient.insKey],
      oid: [''],
      prenomUsage: this.infosPatient.prenom ? this._strUtilsSrv.uppercaseWithoutAccents(this.infosPatient.prenom) : '',
      idDocIdentite: [''],
      idAttrIdentite: [''],
      forceIdentiteValidation: [false],
      villeNaissance: [''],
      paysNaissance: [''],
      lieuNaissanceInconnu: [false]
    });
    if(this.infosPatient.CV){
      this.maskInsAndCV = true;
    }
  }

  public closeAddEditModal(object?: any): void {
    if (object && object.nav && object.nav === 'NAVIGATE_TO_PATIENT_DETAILS') {
      this.closeEmitter.emit(object);
    } else if (object) {
      const loadingModal = this._modalService.openLoading(this._view);
      this.closeEmitter.emit({ object, loadingModal });
    } else {
      this.closeEmitter.emit();
    }
  }

  public stopPropagation(event): void {
    event.stopPropagation();
  }

  public async onSubmit(): Promise<void> {
    const focusMissingField = () => {
      /**
       * Cette fonction parcour les champ required du formGroup
       * et donne le focus au premier champ non valide trouvé
       */
      const mandatoryFields = ['sexe', 'nomNaissance', 'prenom', 'dateNaissance', 'responsable'];
      for (const field of mandatoryFields) {
        if (!this.formGroup?.controls?.[field]?.valid) {
          const f = document.querySelector(`app-add-patient #${field} input`);
          if (f) {
            (f as any).focus();
            break;
          }
        }
      }
    };

    if (!this.formGroup.valid) {
      this.errorMessage = 'Un champ obligatoire est manquant';
      this.isError = true;
      focusMissingField();
      return;
    } else {
      this.errorMessage = undefined;
      this.isError = false;
    }

    this.isSubmitDisabled = true;
    this.formGroup.markAllAsTouched();

    let prenomUsage = '';
    if (this.formGroup && this.formGroup.get('prenomUsage')
      && this.formGroup.get('prenomUsage').value && this.formGroup.get('prenomUsage').value !== '') {
      prenomUsage = this.formGroup.get('prenomUsage').value;
    } else {
      prenomUsage = this.formGroup.get('prenom').value;
    }

    let nom = '';
    let nomUsage = '';
    if (this.formGroup && this.formGroup.get('nom')
      && this.formGroup.get('nom').value && this.formGroup.get('nom').value !== '') {
      nom = this.formGroup.get('nom').value;
    } else {
      nom = this.formGroup.get('nomNaissance').value;
    }

    if (this.formGroup && this.formGroup.get('nomUsage')
      && this.formGroup.get('nomUsage').value && this.formGroup.get('nomUsage').value !== '') {
      nomUsage = this.formGroup.get('nomUsage').value;
    } else {
      nomUsage = nom;
    }

    if (this.formGroup.valid) {
      const object: CreationPatient = {
        nom,
        prenom: this.formGroup.controls.prenom.value,
        dateNaissance: moment(this.formGroup.controls.dateNaissance.value, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        cpNaissance: this.formGroup.controls.cpNaissance.value,
        villeNaissance: this.formGroup.controls.villeNaissance.value,
        paysNaissance: this.formGroup.controls.paysNaissance.value ? this.formGroup.controls.paysNaissance.value : '',
        idTitre: this.formGroup.controls.titre.value,
        sexe: this.formGroup.controls.sexe.value,
        nomNaissance: this.formGroup.controls.nomNaissance.value,
        idResponsableDossier: this.formGroup.controls.responsable.value,
        consentement: this.formGroup.controls.consentement.value,
        adresse: this.formGroup.controls.adresse.value,
        complementAdresse: this.formGroup.controls.compAdresse.value,
        codePostal: this.formGroup.controls.codePostal.value,
        ville: this.formGroup.controls.ville.value,
        email: this.formGroup.controls.email.value,
        telephone: this.formGroup.controls.telephone.value,
        note: this.formGroup.controls.note.value,
        insc: this.formGroup.controls.insc ? this.formGroup.controls.insc.value : undefined,
        ins: this.formGroup.controls.ins ? this.formGroup.controls.ins.value : undefined,
        insKey: this.formGroup.controls.insKey ? this.formGroup.controls.insKey.value : undefined,
        oid: this.formGroup.controls.oid ? this.formGroup.controls.oid.value : undefined,
        prenomUsage,
        nomUsage,
        documentDeValidation: this.formGroup.controls.idDocIdentite.value,
        identiteAttribut: this.formGroup.controls.idAttrIdentite.value,
        forceIdentiteValidation: this.formGroup.controls.forceIdentiteValidation.value,
        prenomsNaissance: this.formGroup.controls.prenomsNaissance ? this.formGroup.controls.prenomsNaissance.value : undefined,
        lieuNaissanceInconnu: this.formGroup.controls.lieuNaissanceInconnu ? this.formGroup.controls.lieuNaissanceInconnu.value : false,
      };

      if (this.formGroup.controls.ins && this.formGroup.controls.ins.value
        && this.formGroup.controls.insKey && this.formGroup.controls.insKey.value
      ) {
        this.couverturePatient = {
          nomAssure: nomUsage,
          insc: this.formGroup.controls.insc ? this.formGroup.controls.insc.value : undefined,
          numSecSociale: this.formGroup.controls.ins.value + this.formGroup.controls.insKey.value,
        };
      }

      this.closeAddEditModal(object);
    } else {
      this.isSubmitDisabled = false;
    }
  }

  public async lectureVitale(): Promise<void> {
    const loadingModal = this._modalService.openLoading(this._view);

    try {
      const listPatientsCarte = await this._cpxHandleSrv.lectureVitale(this._view);
      this._modalService.close(loadingModal);
      const infosPatientCarte = this._mapInfosPatientCarteVitale(listPatientsCarte);
      if (infosPatientCarte.length === 1) {
        if (this.insRight.acces > 0) {
          this._getInsFromVitale(infosPatientCarte[0]);
        } else {
          const alertModal = this._modalService.openAlert(this._view, 'Droits restreints', 'Vous n\'avez pas les droits requis pour accéder à l\'INS du patient.');
        }
      } else {
        await this._openModalPatientCarteVitale(infosPatientCarte);
      }
    }
    catch (e) {
      if (e instanceof CannotOpenSession) {
        this._modalService.openAlert(this._view, 'Erreur', 'Impossible de se connecter au lecteur de carte.');
      } else if (e instanceof NoVitaleCard) {
        this._modalService.openAlert(this._view, 'Erreur', 'Pas de carte vitale insérée.');
      } else if (e instanceof CpxCard) {
        this._modalService.openAlert(this._view, 'Erreur', 'Vous avez inséré une carte cpx.');
      } else if (e instanceof MultipleVitaleCards) {
        const slotNames = e.message.split(',');
        const propositions: Array<any> = [];
        for (const slotName of slotNames) {
          propositions.push({ label: slotName, value: slotName });
        }
        const modal = this._modalService.openModalMultipleChoice(this._view, 'Plusieurs cartes vitale insérées', 'Plusieurs cartes vitales ont été insérées.', 'Choisissez la carte à lire :', propositions);
        const modalSub = modal.instance.closeEmitter.subscribe(async (choice: string | null) => {
          const loadingModal = this._modalService.openLoading(this._view);
          const listPatientsCarte = await this._cpxHandleSrv.lectureVitale(this._view, choice);
          this._modalService.close(loadingModal);
          const infosPatientCarte = this._mapInfosPatientCarteVitale(listPatientsCarte);
          if (infosPatientCarte.length === 1) {
            this._getInsFromVitale(infosPatientCarte[0]);
          } else {
            await this._openModalPatientCarteVitale(infosPatientCarte);
          }
          modalSub.unsubscribe();
        });
      } else if (e instanceof CannotReadVitale) {
        this._modalService.openAlert(this._view, 'Erreur', 'Impossible de lire la carte vitale.');
      } else if (e instanceof VitaleCardRipped) {
        this._modalService.openAlert(this._view, 'Erreur', 'Carte vitale arrachée.');
      }

      this._modalService.close(loadingModal);
      throw (e);
    }
  }

  private _mapInfosPatientCarteVitale(listPatientsCarte: any) {
    const infosPatientCarte: any[] = [];
    for (const [index, patient] of listPatientsCarte.Patients.entries()) {
      let birthday = '';
      if (patient.s_birthday && moment(patient.s_birthday, 'DDMMYYYY').isValid()) {
        birthday = moment(patient.s_birthday, 'DDMMYYYY').format('DD/MM/YYYY');
      } else if (patient.s_birthdayYYYYMMDD && moment(patient.s_birthdayYYYYMMDD, 'YYYYMMDD').isValid()) {
        birthday = moment(patient.s_birthdayYYYYMMDD, 'YYYYMMDD').format('DD/MM/YYYY');
      } else if (patient.s_birthdayYYMMDD && moment(patient.s_birthdayYYMMDD, 'YYMMDD').isValid()) {
        birthday = moment(patient.s_birthdayYYMMDD, 'YYMMDD').format('DD/MM/YYYY');
      }

      infosPatientCarte.push({
        id: index,
        i_birthRank: patient.i_birthRank,
        i_quality: patient.i_quality,
        s_birthday: birthday,
        s_birthname: patient.s_birthname,
        s_certifiedNir: patient.s_certifiedNir ? patient.s_certifiedNir : undefined,
        s_given: patient.s_given,
        s_insC: patient.s_insC ? patient.s_insC : undefined,
        s_name: patient.s_name,
        s_nir: patient.s_nir ? patient.s_nir : undefined
      });
    }
    return infosPatientCarte;
  }

  private async _getInsFromVitale(res: Patients): Promise<void> {
    const filtreSearchPatient: FiltrePatient = {
      nom: res.s_birthname && res.s_birthname !== '' ? res.s_birthname.trim() : undefined,
      prenom: res.s_given && res.s_given !== '' ? res.s_given.trim() : undefined,
      dateNaissance: res.s_birthday && res.s_birthday !== '' ? moment(res.s_birthday, 'DD/MM/YYYY').format('YYYY-MM-DD') : undefined,
      insc: res.s_insC ? res.s_insC : undefined,
      getArchive: true
    };

    try {
      if (filtreSearchPatient.nom && filtreSearchPatient.prenom && filtreSearchPatient.dateNaissance) {
        const patientVitale = await this._patientService.patientsSearchFilters(filtreSearchPatient, {
          perpage: 10,
          currentPage: 1
        });

        if (patientVitale.objects.length > 0) {
          const confirm = this._modalService.openModalConfirmation(
            this._view,
            'Patient',
            'Ce patient existe déjà. Voulez-vous accéder à sa fiche ?',
            []
          );
          const confirmSub = confirm.instance.closeEmitter.subscribe((res: boolean) => {
            if (res) {
              this.closeAddEditModal({
                nav: 'NAVIGATE_TO_PATIENT_DETAILS',
                patientId: patientVitale.objects[0].id
              });
            }
            confirmSub.unsubscribe();
          });
        } else {
          const given = this._strUtilsSrv.uppercaseFirstCharString(res.s_given);
          const givenSplit = given.split(' ');

          console.log(res);
          let sexe = 1;

          if (res.i_quality === 0 && res.s_nir && res.s_nir.charAt(0) === '1') {
            // Dans le cas d'un NIR commençant par 1, le sexe est masculin
            sexe = 2;
          } else if (res.i_quality === 0 && res.s_nir && res.s_nir.charAt(0) === '2') {
            // Dans le cas d'un NIR commençant par 2, le sexe est féminin
            sexe = 3;
          }

          this.infosPatient = {
            nom: res.s_birthname && res.s_birthname !== '' ? res.s_birthname : res.s_name && res.s_name !== '' ? res.s_name : res.s_birthname,
            prenom: givenSplit[0] && givenSplit[0] !== '' ? givenSplit[0] : res.s_given && res.s_given !== '' ? res.s_given : '',
            nomNaissance: res.s_birthname,
            birthday: res.s_birthday,
            sexe: sexe,
            insc: res.s_insC ? res.s_insC : undefined,
          };

          this.initPatientForm();
          this.infosFromInsi = true;
        }
      } else {
        this.infosPatient = {
          nom: res.s_name,
          prenom: this._strUtilsSrv.uppercaseFirstCharString(res.s_given),
          nomNaissance: res.s_birthname,
          birthday: res.s_birthday
        };
        this.initPatientForm();
        this.infosFromInsi = true;
      }
    } catch (e) {
      this._modalService.openAlert(this._view, 'Erreur', 'Impossible d\'afficher le(s) patient(s).');
      throw e;
    }
  }

  private _openModalPatientCarteVitale(infos: any[]): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const modal = this._modalService.openModalSelectList(this._view, 'Patient(s) carte vitale', this.patientVitaleColumnTable, infos, 'Veuillez sélectionner un patient.');
      modal.instance.validButtonLabel = 'Sélectionner';
      const sub = modal.instance.closeEmitter.subscribe(async (res: Patients) => {
        let load: ComponentRef<LoadingModalFragment>;
        try {
          if (res) {
            load = this._modalService.openLoading(this._view);

            const listPatientsCarte = await this._cpxHandleSrv.lectureVitale(this._view);
            const infosPatientCarte = this._mapInfosPatientCarteVitale(listPatientsCarte) as Array<Patients>;
            const patientCardOk = infosPatientCarte.find(p => p.id === res.id && p.s_certifiedNir === res.s_certifiedNir);
            if (!patientCardOk) {
              load.destroy();
              this._modalService.openAlert(this._view, 'Mauvaise carte Vitale', 'La carte Vitale utilisée pour sélectionner un patient n\'est pas la même que la carte actuellement présente dans le lecteur.');
            } else {
              load.destroy();
              if (this.insRight.acces > 0) {
                await this._getInsFromVitale(res);
              } else {
                const alertModal = this._modalService.openAlert(this._view, 'Droits restreints', 'Vous n\'avez pas les droits requis pour accéder à l\'INS du patient.');
              }
            }
          }
          resolve();
        } catch (e) {
          reject(e);
        } finally {
          modal.destroy();
          sub.unsubscribe();
          if (load) {
            load.destroy();
          }
        }
      });
    });
  }

  async lectureInsi() {
    if (this.insRight.acces > 0) {
      const setResourceId = () => {
        const currentProfilStr = localStorage.getItem('currentProfil');
        if (currentProfilStr && currentProfilStr !== '') {
          const currentProfil = JSON.parse(currentProfilStr);
          this._insSrv.resourceId = currentProfil.id;
        }
      };

      if (!this._insSrv.resourceId || this._insSrv.resourceId === '') {
        setResourceId();
      }

      const modalInsi = this._modalService.openModalInsi('Recherche dans l\'INS', this._view);
      const sub = modalInsi.instance.closeEmitter.subscribe(async (res: any) => {
        if (res) {
          if (res.sex !== 'Masculin' && res.sex !== 'Féminin') {
            this._modalService.openAlert(
              this._view, 'Sex non valide', 'Le sexe renvoyé par le service INSi n\'est pas valide.\nPar conséquent, l\'INS ne peut pas rapatrié.'
            );
            return;
          }

          this.formGroup = this._formBuilder.group({
            titre: [''],
            sexe: [this._getSexName(res.sex)],
            nom: [res.nameUsed ? this._strUtilsSrv.uppercaseString(res.nameUsed) : '', [Validators.required, Validators.pattern(REGEX_NAME)]],
            nomNaissance: [this._strUtilsSrv.uppercaseString(res.birthName), [Validators.required, Validators.pattern(REGEX_NAME)]],
            prenomsNaissance: [this._strUtilsSrv.uppercaseString(res.firstNames) || '', [Validators.pattern(REGEX_NAME)]],
            prenom: ['', [Validators.required, Validators.pattern(REGEX_NAME)]],
            dateNaissance: [moment(res.birthday, 'DD/MM/YYYY').toDate(), Validators.required],
            cpNaissance: [res.birthPlace, [Validators.pattern('^[0-9]*$'), Validators.maxLength(5)]],
            responsable: [this.currentUser.id, Validators.required],
            consentement: [true],
            adresse: [''],
            compAdresse: [''],
            codePostal: ['', [Validators.pattern('^[0-9]*$'), Validators.maxLength(5)]],
            ville: [''],
            villeNaissance: [''],
            paysNaissance: [''],
            lieuNaissanceInconnu: [false],
            email: ['', Validators.email],
            telephone: ['', this.checkPhoneNumber],
            note: [''],
            ins: [res.ins],
            insKey: [res.insKey],
            oid: [res.oid],
            prenomUsage: [res.firstName ? this._strUtilsSrv.uppercaseString(res.firstName) : res.firstNameUsed ? this._strUtilsSrv.uppercaseString(res.firstNameUsed) : ''],
            idDocIdentite: [''],
            idAttrIdentite: [''],
            forceIdentiteValidation: [false]
          });

          if (res.ins && res.ins.s_value) {
            this.couverturePatient = {
              nomAssure: res.nameUsed,
              insc: res.ins.s_value + res.ins.s_key
            };
          }

          this.infosFromInsi = true;
        }
        this._modalService.close(modalInsi);
        sub.unsubscribe();
      });


    } else {
      const alertModal = this._modalService.openAlert(this._view, 'Droits restreints', 'Vous n\'avez pas les droits requis pour accéder à l\'INS du patient.');
    }
  }

  public initFormFromOustide(patient: CreationPatient) {
    this.formGroup = this._formBuilder.group({
      titre: [patient.idTitre],
      sexe: [patient.sexe],
      nom: [patient.nom, [Validators.required, Validators.pattern(REGEX_NAME)]],
      nomNaissance: [patient.nomNaissance.toLocaleUpperCase(), [Validators.required, Validators.pattern(REGEX_NAME)]],
      prenomsNaissance: [patient.prenomsNaissance || '', [Validators.pattern(REGEX_NAME)]],
      prenom: [this._strUtilsSrv.uppercaseFirstCharString(patient.prenom), [Validators.required, Validators.pattern(REGEX_NAME)]],
      dateNaissance: [moment(patient.dateNaissance).toDate(), Validators.required],
      cpNaissance: [patient.cpNaissance, [Validators.pattern('^[0-9]*$'), Validators.maxLength(5)]],
      responsable: [this.currentUser?.id, Validators.required],
      consentement: [patient.consentement],
      adresse: [patient.adresse],
      compAdresse: [patient.complementAdresse],
      codePostal: [patient.codePostal, [Validators.pattern('^[0-9]*$'), Validators.maxLength(5)]],
      ville: [patient.ville],
      villeNaissance: [patient.villeNaissance],
      paysNaissance: [patient.paysNaissance],
      lieuNaissanceInconnu: [patient.lieuNaissanceInconnu],
      email: [patient.email, Validators.email],
      telephone: [patient.telephone, this.checkPhoneNumber],
      note: [patient.note],
      ins: [patient.ins],
      insKey: [patient.insKey],
      oid: [patient.oid],
      prenomUsage: patient.prenomUsage ? patient.prenomUsage : '',
      forceIdentiteValidation: [patient.forceIdentiteValidation],
      idDocIdentite: [''],
      idAttrIdentite: ['']
    });
  }

  public canDisplayPickName(): boolean {
    const prenomsNaissance: Array<string> | undefined = this.formGroup?.get('prenomsNaissance')?.value?.split(' ');
    if (prenomsNaissance && prenomsNaissance.length > 0 && prenomsNaissance[0] !== '') {
      if (this.formGroup.get('prenom')) {
        this.formGroup.get('prenom').setValue(prenomsNaissance[0]);
      }
      return true;
    } else {
      return false;
    }
  }

  public async firstNamePropals(): Promise<void> {
    const prenomsNaissance: Array<string> | undefined = this.formGroup?.get('prenomsNaissance')?.value?.split(' ');
    if (prenomsNaissance && prenomsNaissance.length > 0) {
      const propals = [{ label: prenomsNaissance[0], value: prenomsNaissance[0] }];

      if (prenomsNaissance[1]) {
        propals.push({ label: `${prenomsNaissance[0]} ${prenomsNaissance[1]}`, value: `${prenomsNaissance[0]} ${prenomsNaissance[1]}` });
        propals.push({ label: `${prenomsNaissance[0]}-${prenomsNaissance[1]}`, value: `${prenomsNaissance[0]}-${prenomsNaissance[1]}` });
      }

      const modal = this._modalService.openModalMultipleChoice(
        this._view, '1er prénom de naissance',
        'Vous pouvez sélectionner un 1er prénom de naissance parmis cette liste :', '', propals
      );
      const sub = modal.instance.closeEmitter.subscribe(c => {
        if (c && this.formGroup?.get('prenom')) {
          this.formGroup.get('prenom').setValue(c);
        }
        sub.unsubscribe();
      });
    }
  }

  public doUppercaseInputValue(absCtrl: AbstractControl) {
    let value = absCtrl.value;

    const reg = /[^a-zA-Z-\s\']/g;

    // On retire les accent et passe les caractères en majuscules
    value = this._strUtilsSrv.removeAccents(this._strUtilsSrv.uppercaseString(value));

    // On nettois la string des caractères non voulus
    value = (value as string).replace(reg, '');

    // On set la valeur pour la mettre à jour dans l'interface
    absCtrl.setValue(value);
  }

  public sanitizeEntries(absCtrl: AbstractControl) {
    if (!absCtrl || typeof absCtrl.value !== 'string') return;
    
    // On supprime les chevrons < et > et l'esperluette &
    // On ne supprime PAS l'apostrophe (') pour ne pas casser les noms
    const reg = /[<>]/g;
    const sanitizedValue = absCtrl.value.replace(reg, '');
    
    if (absCtrl.value !== sanitizedValue) {
      absCtrl.setValue(sanitizedValue);
    }
  }

  public doUppercaseFirstLetterInputValue(absCtrl: AbstractControl) {
    absCtrl.setValue(this._strUtilsSrv.uppercaseFirstCharString(absCtrl.value));
  }

  private _getSexName(sex: string) {
    let sexName: string;
    switch (sex) {
      case 'Inconnu': {
        sexName = '';
        break;
      }
      case 'Masculin': {
        sexName = 'HOMME';
        break;
      }
      case 'Féminin': {
        sexName = 'FEMME';
        break;
      }
      case 'Indéterminé': {
        sexName = 'INDETERMINE';
        break;
      }
      default: {
        sexName = '';
        break;
      }
    }
    return sexName;
  }

  public selectCity(commune: any) {
    this.formGroup.get('villeNaissance').setValue(commune.nom);
    this.formGroup.get('cpNaissance').setValue(commune.code);
    this.communesNaissance$ = null;
    this.activeSearchField = null;
  }

  public onVilleChange(value: string, field: 'ville' | 'code' = 'ville') {
    this.activeSearchField = field;
    this.searchVilleSubject.next(value);
  }

  executeSearchVille(value: string) {
    const loader = this._modalService.openLoading(this._view);
    try {
      const isNumeric = /^[0-9]+$/.test(value);
      const dateNaissanceValue = this.formGroup?.get('dateNaissance')?.value;
      const dateNaissance = dateNaissanceValue ? moment(dateNaissanceValue).format('YYYY-MM-DD') : undefined;

      const minLengthNumeric = this.isDomTomChecked ? 3 : 5;

      let obs$: Observable<any> | null = null;

      if (isNumeric && value.length >= minLengthNumeric) {
        obs$ = this.isDomTomChecked 
          ? this._apiMetadataSrv.searchCollectivitesDOutreMer(value)
          : this._apiMetadataSrv.searchCommunesByInseeCode(value);
      } else if (!isNumeric && value.length > 1) {
        obs$ = this.isDomTomChecked
          ? this._apiMetadataSrv.searchCollectivitesDOutreMer(value)
          : this._apiMetadataSrv.searchCommunesByName(value, dateNaissance);
      }

      if (obs$) {
        this.communesNaissance$ = obs$.pipe(
          catchError((error) => {
            this._snackBar.openSnackBarError('Une erreur est survenue lors de la récupération des villes, veuillez réessayer.');
            return of([]);
          }),
          finalize(() => {
            loader.destroy();
          })
        );
      } else {
        loader.destroy();
        this.communesNaissance$ = null;
      }
    } catch (error) {
      loader.destroy();
      this._snackBar.openSnackBarError('Une erreur est survenue lors de la récupération des villes, veuillez réessayer.');
    }
  }

  ngOnDestroy() {
    if (this.searchVilleSub) {
      this.searchVilleSub.unsubscribe();
    }
  }

  public onPaysChange(code: string) {
    if (this.formGroup.get('lieuNaissanceInconnu')?.value) {
      return;
    }

    if (code) {
      const pays = this.paysList.find(p => p.id === code);
      const isFrance = pays && pays.libelle.toLowerCase().startsWith('france');
      
      if (!isFrance) {
        this.formGroup.get('cpNaissance').setValue(code);
      }
    } else {
      this.formGroup.get('cpNaissance').setValue(null);
    }
  }

  private _sexIdxToStr(idx: number): string {
    switch (idx) {
      case 1:
        return 'INDETERMINE';
      case 2:
        return 'HOMME';
      case 3:
        return 'FEMME';
      default:
        return '';
    }
  }

  public checkPhoneNumber(control: AbstractControl): { [key: string]: boolean } | null {
    const regexPhone = /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/gmi;
    if (control.value !== undefined && control.value !== '' && !regexPhone.test(control.value)) {
      return { patternError: true };
    }
    return null;
  }
}
